import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import { Autocomplete } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleSubmitNewBoldAlert } from "./EditCameraUtils/handleSubmitNewBoldAlert";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";

export const AddBoldAlertDialog = ({
  setAddBoldAlertDialogOpen,
  addBoldAlertDialogOpen,
  boldAlerts,
  setBackdropLoadingScreenOn,
  setCameraGeneralInfo,
  setCameraGeneralInfoBackup,
  setGeneralInfoChangesMade,
  setPatchObject,
  setBoldAlerts,
  setActiveTab,
  cameraGeneralInfoBackup,
  setIgnoreZonesBreadCrumbs,
  handleSitesBreadcrumbClick,
  handleSingularSiteBreadcrumbClick,
  cameraGeneralInfo,
  immixAlerts,
  setAddImmixAlertDialogOpen,
  setSendingImmixTest,
  setImmixTestSuccessDialogOpen,
  setImmixTestFailDialogOpen,
  setDeleteImmixAlertDialogOpen,
  sureviewAlerts,
  setAddSureviewAlertDialogOpen,
  cameraWebhookData,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  immixAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
}: {
  setAddBoldAlertDialogOpen: Dispatcher<boolean>;
  addBoldAlertDialogOpen: boolean;
  boldAlerts: any;
  setBackdropLoadingScreenOn: any;
  setCameraGeneralInfo: any;
  setCameraGeneralInfoBackup: any;
  setGeneralInfoChangesMade: any;
  setPatchObject: any;
  setBoldAlerts: any;
  setActiveTab: any;
  cameraGeneralInfoBackup: any;
  setIgnoreZonesBreadCrumbs: any;
  handleSitesBreadcrumbClick: any;
  handleSingularSiteBreadcrumbClick: any;
  cameraGeneralInfo: any;
  immixAlerts: any;
  setAddImmixAlertDialogOpen: any;
  setSendingImmixTest: any;
  setImmixTestSuccessDialogOpen: any;
  setImmixTestFailDialogOpen: any;
  setDeleteImmixAlertDialogOpen: any;
  sureviewAlerts: any;
  setAddSureviewAlertDialogOpen: any;
  cameraWebhookData: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: any;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: any;
  immixAlertsOnCamera: any;
  sureViewAlertsOnCamera: any;
  siteInfo: any;
  webhooksAlertsOnCamera: any;
  sentinelAlertsOnCamera: any;
  boldAlertsOnCamera: any;
  patriotAlertsOnCamera: any;
  softguardAlertsOnCamera: any;
  evalinkAlertsOnCamera: boolean;
}) => {
  const { cameraStreams, cameraStreamsPatchObject } = useEditCameraStore();

  const streamNames = new Map();
  cameraStreams?.forEach((object: any, index: number) => {
    streamNames.set(`${object.name} (${object.product})`, index);
  });

  const navigate = useNavigate();

  const [postObject, setPostObject] = React.useState({
    id: -1,
    bold_server: "",
    bold_port: "",
    bold_id: "",
    bold_sdnis: "",
    bold_zone: "",
    bold_alarmtype: "",
  });

  const [selectedStreamNames, setSelectedStreamNames] = React.useState<
    string[]
  >([]);

  React.useEffect(() => {
    if (boldAlerts[0]) {
      setPostObject({
        id: -1,
        bold_server: boldAlerts[0].bold_server,
        bold_port: boldAlerts[0].bold_port,
        bold_id: boldAlerts[0].bold_id,
        bold_sdnis: boldAlerts[0].bold_sdnis,
        bold_zone: boldAlerts[0].bold_zone,
        bold_alarmtype: boldAlerts[0].bold_alarmtype,
      });
    }
  }, []);

  return (
    <Dialog open={addBoldAlertDialogOpen}>
      <DialogTitle id="alert-dialog-title">Add Bold Alert</DialogTitle>
      <DialogContent>
        {cameraStreams && cameraStreams.length > 1 && (
          <div>
            <FormLabel component="legend" sx={{ paddingBottom: 1 }}>
              {" "}
              Streams*
            </FormLabel>
            <Autocomplete
              multiple
              options={cameraStreams.map((object: any) => {
                return `${object.name} (${object.product})`;
              })}
              sx={{ width: 400 }}
              renderInput={(params) => <TextField {...params} />}
              onChange={(event, value) => {
                setSelectedStreamNames(value);
              }}
            />
            <br></br>
          </div>
        )}
        <TextField
          id="bold_server"
          variant="standard"
          label="Bold Server"
          defaultValue={boldAlerts[0] ? boldAlerts[0].bold_server : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, bold_server: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="bold_port"
          variant="standard"
          label="Bold Port"
          defaultValue={boldAlerts[0] ? boldAlerts[0].bold_port : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, bold_port: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="bold_id"
          variant="standard"
          label="Bold Id"
          defaultValue={boldAlerts[0] ? boldAlerts[0].bold_id : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, bold_id: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="bold_sdnis"
          variant="standard"
          label="Bold sdnis"
          defaultValue={boldAlerts[0] ? boldAlerts[0].bold_sdnis : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, bold_sdnis: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="bold_zone"
          variant="standard"
          label="Bold Zone"
          defaultValue={boldAlerts[0] ? boldAlerts[0].bold_zone : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, bold_zone: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="bold_alarmtype"
          variant="standard"
          label="Bold Alarm Type"
          defaultValue={boldAlerts[0] ? boldAlerts[0].bold_alarmtype : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, bold_alarmtype: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
          helperText="Alarm type for alert, default is BA (Burglary alarm)."
        />
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddBoldAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            const selectedStreamIndexs: number[] = [];

            const streamsObjectToPost = JSON.parse(
              JSON.stringify(cameraStreamsPatchObject)
            );

            if (cameraStreams && cameraStreams.length > 1) {
              selectedStreamNames.forEach((streamName: string) => {
                selectedStreamIndexs.push(streamNames.get(streamName));
              });

              selectedStreamIndexs.forEach((streamIndex: number) => {
                if (streamsObjectToPost[streamIndex]) {
                  streamsObjectToPost[streamIndex].bold_alerts = [
                    ...streamsObjectToPost[streamIndex].bold_alerts,
                    postObject,
                  ];
                }
              });
            }

            if (cameraStreams && cameraStreams.length === 1) {
              streamsObjectToPost[0].bold_alerts.push(postObject);
            }

            setAddBoldAlertDialogOpen(false);
            setBackdropLoadingScreenOn(true);
            handleSubmitNewBoldAlert(
              cameraGeneralInfo,
              boldAlerts,
              streamsObjectToPost,
              navigate,
              setBackdropLoadingScreenOn,
              setCameraGeneralInfo,
              setCameraGeneralInfoBackup,
              setGeneralInfoChangesMade,
              setPatchObject,
              setBoldAlerts,
              setActiveTab,
              setAddBoldAlertDialogOpen,
              cameraGeneralInfoBackup,
              setIgnoreZonesBreadCrumbs,
              handleSitesBreadcrumbClick,
              handleSingularSiteBreadcrumbClick,
              immixAlerts,
              setAddImmixAlertDialogOpen,
              setSendingImmixTest,
              setImmixTestSuccessDialogOpen,
              setImmixTestFailDialogOpen,
              setDeleteImmixAlertDialogOpen,
              sureviewAlerts,
              setAddSureviewAlertDialogOpen,
              cameraWebhookData,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              patriotAlerts,
              setAddPatriotAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              immixAlertsOnCamera,
              sureViewAlertsOnCamera,
              siteInfo,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera
            );
          }}
          text="Submit"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
